import React from 'react';
import { AnalyticsReports } from '@/components/dashboard';

const Dashboard: React.FC = () => {
  return <AnalyticsReports />;
};

export default Dashboard;
